// Zuwad (WhatsApp style, per user): archived chats leave the main list and only
// archived chats show in the archived list; pinned chats lead the main list.

// `activeFilters.archived` is true in the archived list. The Mentions, Participating and
// Unattended views (`conversationType`) show archived chats too, as the server does.
export const matchesArchiveView = (
  conversation,
  { archived = false, conversationType } = {},
  isArchived = () => false
) =>
  Boolean(conversationType) ||
  Boolean(archived) === isArchived(conversation.id);

// Pinned first, most recently pinned first; the rest keep their order.
export const sortPinnedFirst = (conversations, getPinnedAt) =>
  [...conversations].sort((a, b) => getPinnedAt(b.id) - getPinnedAt(a.id));

// The chat has unread messages and the line was mentioned after it was last opened.
export const hasUnreadLineMention = (conversation, mentionAt) =>
  conversation.unread_count > 0 &&
  mentionAt > (conversation.agent_last_seen_at || 0);
